<template>
  <div>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-row class="ma-0">
      <div>
        <v-btn @click="createNote" color="primary">
          <v-icon class="mr-2">mdi-plus</v-icon>
            {{ languageData.btnAddNote }}
        </v-btn>
      </div>
    </v-row>
    <v-row justify="center">
      <NotesTable :noteableType="noteableType"></NotesTable>
    </v-row>
      <ModalInfo :layout="'modalForm'" :scrollable="true" :hidden-agree-btn="true" @clicked="hideModalNote" :show-modal="isShowNoteModal" >
      <template v-slot:body>
        <v-form ref="formNotes">
          <p class="text-h5">{{ languageData.sectionProject.notes }}</p>
          <v-textarea
              class="mt-5"
              outlined
              :placegholder="languageData.labels.anotherNote"
              :label="languageData.labels.anotherNote"
              v-model="noteContent"
              rows="6"></v-textarea>
              <v-btn 
                color="primary"
                @click="pushNote"
                >
              {{ languageData.btnSaveNote }}</v-btn>
        </v-form>
      </template>
    </ModalInfo>
  </div>
</template>

<script type="text/javascript">
  import { mapActions, mapState } from "vuex";
  import NotesTable from "./NotesTable";
  import eventBus from "../../../event-bus/eventBus";
  import ModalInfo from "../../../components/ModalInfo/ModalInfo";

  export default {
    name: "Notes",
    props: {
      noteableType: String
    },
    components: {
      NotesTable, ModalInfo
    },
    methods: {
      ...mapActions("getNoteHeaders", ["getNoteHeaders"]),
      ...mapActions("saveNote", ["storeNote"]),
      ...mapActions("updateVisibleNoteModal", ["updateVisibleNoteModal"]),

      pushNote: function() {
        let content = this.noteContent;
        let noteableType = this.noteableType;
        this.storeNote({ creds: { content, noteableType } });
        this.updateVisibleNoteModal(false);
      },
      getSnackbarSuccess: function(title, message) {
        this.snackbar = {
          color: "success",
          icon: "check_circle",
          mode: "multi-line",
          position: "top",
          timeout: 7500,
          corner: 'right',
          title: title,
          text: message,
          visible: true
        };
      },
      hideModalNote: function() {
        this.updateVisibleNoteModal(false);
      },
      createNote: function() {
        this.updateVisibleNoteModal(true);        
      }
    },
    data() {
      return {
        noteContent: "",
        snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: null,
          text: null,
          corner: null,
          timeout: 7500,
          title: null,
          visible: false
        },
      }
    },
    mounted() {
      eventBus.$on("deleteNoteSuccess", (dataReceive) => {
        this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
      });
      eventBus.$on("saveNoteSuccess", (dataReceive) => {
        this.noteContent = "";
        this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
      });
      eventBus.$on("updateNoteSuccess", (dataReceive) => {
        this.noteContent = "";
        this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
      })
    },
    computed: {
      ...mapState("updateVisibleNoteModal", {
        isShowNoteModal: state => state.isShowNoteModal
      })
    }
  }
</script>